import {getData} from "./v2";


export function setupContactClicks(db: IDBDatabase) {

    const widgetLinks = document.getElementsByClassName('arcano-uploader-widget')!;
    for(let i=0; i<widgetLinks.length; i++){
        let widgetLink = widgetLinks[i] as HTMLElement;
        if(!widgetLink){
            return
        }
        const url = new URL(widgetLink.dataset.arcanoLink!);
        const uid = url.searchParams.get('public');
        if(!uid) {
            return
        }

        widgetLink.addEventListener('click', (e) =>{
            e.preventDefault()
            const tableMode = document.getElementById('table_mode') as HTMLInputElement;
            tableMode.value = uid;
            document.querySelectorAll('.sidebar-button').forEach((value) => value.classList.remove('active'))
            widgetLink.classList.add('active')
            getData(db).then(() => {})
        })
}}